import { z } from "zod";
import {
  CommandIdSchema,
  HerSkinRunIdSchema,
  HerSkinSessionIdSchema,
  IsoDateTimeSchema,
  StableIdSchema,
} from "./common.js";
import { RunStatusSchema } from "./run.js";

export const AttachmentRefSchema = z
  .object({
    attachmentId: StableIdSchema,
  })
  .strict();

export const SubmitPromptRequestSchema = z
  .object({
    commandId: CommandIdSchema,
    sessionId: HerSkinSessionIdSchema,
    text: z
      .string()
      .min(1)
      .max(100_000)
      .refine((value) => value.trim().length > 0, {
        message: "Prompt 不能只包含空白字符",
      }),
    attachments: z
      .array(AttachmentRefSchema)
      .max(5)
      .default([])
      .refine(
        (items) => new Set(items.map((item) => item.attachmentId)).size === items.length,
        "同一附件不能在一条消息中重复引用",
      ),
    clientRevision: z.number().int().min(0),
  })
  .strict();

export const SubmitPromptResponseSchema = z
  .object({
    commandId: CommandIdSchema,
    sessionId: HerSkinSessionIdSchema,
    runId: HerSkinRunIdSchema,
    disposition: z.enum(["accepted", "duplicate"]),
    status: RunStatusSchema,
    acceptedAt: IsoDateTimeSchema,
  })
  .strict();

export type SubmitPromptRequest = z.infer<typeof SubmitPromptRequestSchema>;
export type SubmitPromptResponse = z.infer<typeof SubmitPromptResponseSchema>;
export type AttachmentRef = z.infer<typeof AttachmentRefSchema>;
